export const UPDATE_HEADER = 'UPDATE_HEADER'

export const updateHeader = (header) => ({
  type: UPDATE_HEADER,
  header,
})
